import { render, staticRenderFns } from "./workCreate.vue?vue&type=template&id=45d7ad4e&scoped=true"
import script from "./workCreate.vue?vue&type=script&lang=js"
export * from "./workCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d7ad4e",
  null
  
)

export default component.exports